import React from "react";
import "./Career.scss";
import careerNotice from "../../assets/career/career_notice.jpg";

const Career = () => {
  return (
    <>
      <div className="container">
        <div className="career">
          <div className="heading_box">Career</div>
          <div className="career_content">
            <img src={careerNotice} className="img-fluid" alt="" />
            <div>
              {/* <p>Source</p> */}
              <p className="mt-2">
                <i>Source: Page-20 , May-3 </i>
              </p>
              <p>
                <i>
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://epaper.thefinancialexpress.com.bd/?archiev=yes&arch_date=03-05-2024#"
                  >
                    https://epaper.thefinancialexpress.com.bd/?archiev=yes&arch_date=03-05-2024#
                  </a>
                </i>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Career;
